import(/* webpackMode: "eager", webpackExports: ["CertificateSection"] */ "/app/components/homepage/certificate_section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeroFooter"] */ "/app/components/homepage/hero_footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/app/components/homepage/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MenuSection"] */ "/app/components/homepage/menu_section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsSection"] */ "/app/components/homepage/news_section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductSlideShow"] */ "/app/components/homepage/product_slide_show.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReviewSection"] */ "/app/components/homepage/review_section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TitleSection"] */ "/app/components/homepage/title_section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WhyUsSection"] */ "/app/components/homepage/why_us_section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShoppingPlatformsSection"] */ "/app/components/products/shopping_platforms_section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/esm/Stack/Stack.js");
